import { InquiryPeriod } from "../../store/inquiries/types";
import usePeriods from "../common/usePeriods";

export default function useJuustojenValmistusPeriods(): InquiryPeriod[] {
  return usePeriods("juustojen-valmistus");
}
